import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

class HomeBlogSlider {
  constructor() {
    this.init();
  }

  init() {
    new Swiper(".home-blog__swiper", {
      modules: [Navigation, Pagination],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".home-blog__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".home-blog__next",
        prevEl: ".home-blog__prev",
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 24 },
      },
    });
  }
}

export default HomeBlogSlider;
